import { render, staticRenderFns } from "./BuySubscription.vue?vue&type=template&id=44744156"
import script from "./BuySubscription.vue?vue&type=script&lang=js"
export * from "./BuySubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports